import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {SelectButton} from "primeng/selectbutton";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {createVisibleErrorMessage} from "../form-error/form-error.utils";

@Component({
  selector: 'homey-household-size-input',
  imports: [
    SelectButton,
    ReactiveFormsModule,
  ],
  templateUrl: './household-size-input.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HouseholdSizeInputComponent {
  control = input.required<FormControl<number | undefined>>();
  public readonly errorMessage = input<string | Record<string, string>>();

  protected householdSizeOptions: { value: number, label: string }[] = [
    {value: 1, label: "1"},
    {value: 2, label: "2"},
    {value: 3, label: "3"},
    {value: 4, label: "4"},
    {value: 5, label: "5"},
    {value: 6, label: "6"},
    {value: 7, label: "7"},
  ];

  protected readonly visibleErrorMessage = createVisibleErrorMessage(this.control, this.errorMessage);
}
